var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCreditCardIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "14px",
    viewBox: "0 0 22 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Credit Card icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19,0 L3,0 C1.61928813,0 0.5,1.11928813 0.5,2.5 L0.5,11.5 C0.5,12.8807119 1.61928813,14 3,14 L19,14 C19.6630412,14 20.298926,13.7366079 20.767767,13.267767 C21.2366079,12.798926 21.5,12.1630412 21.5,11.5 L21.5,2.5 C21.5,1.83695878 21.2366079,1.20107399 20.767767,0.732233047 C20.298926,0.263392101 19.6630412,0 19,0 Z M20.5,11.5 C20.5,12.3284271 19.8284271,13 19,13 L3,13 C2.17157288,13 1.5,12.3284271 1.5,11.5 L1.5,6 L20.5,6 L20.5,11.5 Z M20.5,5 L1.5,5 L1.5,2.5 C1.5,1.67157288 2.17157288,1 3,1 L19,1 C19.8284271,1 20.5,1.67157288 20.5,2.5 L20.5,5 Z M11,10 L4,10 L4,9 L11,9 L11,10 Z M18,10 L14,10 L14,9 L18,9 L18,10 Z",
    id: "Credit-Card-icon",
    fill: "#061556",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCardIcon);
export default __webpack_public_path__ + "static/media/credit_card_icon.4f517dbf28005db3ba3a19448ee55a95.svg";
export { ForwardRef as ReactComponent };